/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetOneToolTeamDto } from './GetOneToolTeamDto';
import {
    GetOneToolTeamDtoFromJSON,
    GetOneToolTeamDtoFromJSONTyped,
    GetOneToolTeamDtoToJSON,
} from './GetOneToolTeamDto';

/**
 * 
 * @export
 * @interface GetTeamDto
 */
export interface GetTeamDto {
    /**
     * 
     * @type {string}
     * @memberof GetTeamDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetTeamDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetTeamDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamDto
     */
    email?: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetTeamDto
     */
    manager: GetEmployeeDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamDto
     */
    active: boolean;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetTeamDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamDto
     */
    pae: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamDto
     */
    tv: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTeamDto
     */
    pathPhaseId?: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetTeamDto
     */
    pathPhase?: GetDictionaryDto;
    /**
     * 
     * @type {GetOneToolTeamDto}
     * @memberof GetTeamDto
     */
    oneToolTeam?: GetOneToolTeamDto;
}

/**
 * Check if a given object implements the GetTeamDto interface.
 */
export function instanceOfGetTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "manager" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "pae" in value;
    isInstance = isInstance && "tv" in value;

    return isInstance;
}

export function GetTeamDtoFromJSON(json: any): GetTeamDto {
    return GetTeamDtoFromJSONTyped(json, false);
}

export function GetTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'manager': GetEmployeeDtoFromJSON(json['manager']),
        'active': json['active'],
        'company': GetCompanyDtoFromJSON(json['company']),
        'pae': json['pae'],
        'tv': json['tv'],
        'pathPhaseId': !exists(json, 'pathPhaseId') ? undefined : json['pathPhaseId'],
        'pathPhase': !exists(json, 'pathPhase') ? undefined : GetDictionaryDtoFromJSON(json['pathPhase']),
        'oneToolTeam': !exists(json, 'oneToolTeam') ? undefined : GetOneToolTeamDtoFromJSON(json['oneToolTeam']),
    };
}

export function GetTeamDtoToJSON(value?: GetTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'name': value.name,
        'email': value.email,
        'manager': GetEmployeeDtoToJSON(value.manager),
        'active': value.active,
        'company': GetCompanyDtoToJSON(value.company),
        'pae': value.pae,
        'tv': value.tv,
        'pathPhaseId': value.pathPhaseId,
        'pathPhase': GetDictionaryDtoToJSON(value.pathPhase),
        'oneToolTeam': GetOneToolTeamDtoToJSON(value.oneToolTeam),
    };
}

